
<template>

  <svg class="w-full stroke-blue-fresh" xmlns="http://www.w3.org/2000/svg" width="1250" height="2" viewBox="0 0 1250 2" fill="none">
    
    <path d="M0 1H2000" />
    
  </svg>

</template>